import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import useUserLocation from "./useUserLocation";

const useCurrentLocation = () => {
  const currentLocationDetails = useSelector((state) => state?.counter?.location);
  const { location, fetchLocation } = useUserLocation();

  const [locationData, setLocationData] = useState({ city: "", locality: "" });
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchLocation();
  }, []);

  useEffect(() => {
    if (currentLocationDetails?.city) {
      setLocationData({
        city: currentLocationDetails.city,
        locality: currentLocationDetails.locality || "",
      });
      setIsLoading(false);
    } else if (!location.city) {
      fetchLocation();
    }
  }, [currentLocationDetails]);

  useEffect(() => {
    if (!currentLocationDetails?.city && location.city) {
      setLocationData({
        city: location.city,
        locality: location.locality || "",
      });
      setIsLoading(false);
    }
  }, [location]);

  return { ...locationData, isLoading };
};

export default useCurrentLocation;
